module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job-opening"
  }, [(_vm.currentOpening) ? _c('div', {
    staticClass: "job-detail job-post"
  }, [_c('div', {
    staticClass: "banner text-center relative"
  }, [_c('div', [_c('h1', {
    staticClass: "text-white"
  }, [_vm._v(_vm._s(_vm.currentOpening.title))]), _c('p', {
    staticClass: "text-white"
  }, [_vm._v(_vm._s(_vm.currentOpening.location) + " - " + _vm._s(_vm.currentOpening.type))])])]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row padding-left-xs-1 padding-right-xs-1"
  }, [_c('div', {
    staticClass: "margin-top-xs-1 margin-top-sm-1 margin-bottom-xs-1 margin-bottom-sm-1",
    domProps: {
      "innerHTML": _vm._s(_vm.currentOpening.transpiled)
    }
  })])])]) : _vm._e(), (_vm.openings.length) ? _c('div', {
    staticClass: "job-listing job-list padding-bottom-sm-1"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "text-center margin-top-sm-1 margin-bottom-sm-1 margin-top-xs-1 margin-bottom-xs-1"
  }, [_vm._v(_vm._s(_vm.currentOpening ? 'All Our Jobs' : 'Interested? Come join us!'))]), _c('ul', {
    staticClass: "list row padding-left-xs-0 padding-right-xs-0 padding-bottom-sm-1 padding-bottom-xs-1"
  }, _vm._l((_vm.openings), function(opening) {
    return _c('li', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-content text-center"
    }, [_c('h3', {
      staticClass: "mb0 uppercase"
    }, [_vm._v(_vm._s(opening.title) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "small"
    }), _vm._v(" " + _vm._s(opening.location))]), _c('p', {
      staticStyle: {
        "flex-grow": "1"
      }
    }, [_vm._v(_vm._s(opening.excerpt))]), _c('p', {
      staticClass: "small text-center"
    }, [_c('a', {
      staticClass: "uppercase underline",
      attrs: {
        "href": ("#" + (opening.id))
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.openingId = opening.id
        }
      }
    }, [_vm._v("Read More  ")])])])])
  }))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59737295"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CMSJobOpening.vue
// module id = 286
// module chunks = 15